/**
 * Network Status Hook
 * Detects when user is online/offline (for UI such as OfflineBanner).
 * React Query online state is wired separately via onlineManagerSetup.js.
 */

import { useEffect, useState } from 'react';
import logger from '../logger';

export const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      logger.info('Network: Back online');
    };

    const handleOffline = () => {
      setIsOnline(false);
      logger.warn('Network: You are offline');
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Keep hook state aligned if the page loaded offline
    setIsOnline(navigator.onLine);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return { isOnline };
};

export default useNetworkStatus;
